export default {
  appName: 'Autengo',
  logo: '/autengo-brand_2x.png',
  logoLight: '/autengo-white_2x.png',
  primary: '#1635FB',
};
